import React from "react";

const IconLGTBIQ = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">
      <mask
        id="mask0_38_211"
        style={{ maskType: "luminance" }}
        width="40"
        height="40"
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z"></path>
      </mask>
      <g mask="url(#mask0_38_211)">
        <path fill="#9C27B0" d="M0 33.203l20-2.5 20 2.5V40H0v-6.797z"></path>
        <path fill="#0052B4" d="M0 26.563l20-2.5 20 2.5v6.64H0v-6.64z"></path>
        <path fill="#6DA544" d="M0 19.922l20-2.5 20 2.5v6.64H0v-6.64z"></path>
        <path fill="#FFDA44" d="M0 13.281l20-2.5 20 2.5v6.64H0v-6.64z"></path>
        <path fill="#FF9811" d="M0 6.64l20-2.5 20 2.5v6.641H0v-6.64z"></path>
        <path fill="#D80027" d="M0 0h40v6.64H0V0z"></path>
      </g>
    </svg>
  );
};

export default IconLGTBIQ;
